import CompanyServices from "../Pages/ServitorCompanies/CompanyServices";
import Login from "../Pages/Auth/Login";
import VerifyOTP from "../Pages/Auth/VerifyOTP";

import Profile from "../Pages/Profile/Profile";

import Splash from "../Pages/Splash";
import SetRequestOptions from "../Pages/Requests/SetRequestOptions";

import Requests from "../Pages/Requests/Requests";
import Content from "../Pages/Profile/Content";
import Request from "../Pages/Requests/Request";



const appRoutes = [
    {
        pageId : 0,
        path: "/",
        component: <Splash />,
    },
    {
        pageId : 1,
        path: "/company/:id",
        component: <CompanyServices />,
    },
    {
        pageId : 2,
        path: "/login",
        component: <Login />,
    },
    {
        pageId : 3,
        path: "/verify",
        component: <VerifyOTP />,
    },
    {
        pageId : 4,
        path: "/profile",
        component: <Profile />,
    },
    {
        pageId : 5,
        path: "/request-options",
        component: <SetRequestOptions />,
    },
    {
        pageId : 6,
        path: "/requests",
        component: <Requests />,
    },
    {
        pageId : 7,
        path: "/requests/:id",
        component: <Request />,
    },
    {
        pageId : 8,
        path: "/contents/:slug",
        component: <Content />,
    },

];
export default appRoutes;